module.exports = __webpack_public_path__ + "static/media/register.971dd430.jpg";